import $ from "jquery";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import {
  isAlphaNumeric,
  isAlphaNumericStrict,
  isNumber,
  IsNumberKey,
  isNumberOnly,
  normalizePath,
  poNumberStartWith,
} from "../../../Layout/Common/common";
import { axiosInstance } from "../../../axios/axiosInstance";
import { useAuth } from "../../../Context/AuthContext";
import { takePendingOrderCommentsOpen } from "../../../Context/hook/tillRedirect";
import { useNoteAlert } from "../../../Context/pleaseNote";
import {
  ORDER_COMMENTS_ALERT,
  PAYMENT_METHOD_STRING,
  PONUMBER_ALLOW_DUPLICATE,
  SHIPPING_METHOD,
} from "../../../constants";
import { debounce } from "lodash";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { useParams } from "react-router-dom";

export const OrderNoWithCommands = () => {
  const {
    selectedPaymentType,
    poNumber,
    setPoNumber,
    orderCommands,
    setOrderCommands,
    deliveryMethod,
    poNumberRequired,
    poNumberRules,
  } = useContext(GlobalContext);
  const [orderIdRequired, setOrderIdRequired] = useState("");
  const [error, setError] = useState("");
  const [isMandatory, setIsMandatory] = useState(false);
  const { userId } = useAuth();
  const [po_start_with, setPoStartWith] = useState(false);
  const [po_start_with_value, setPoStartWithValue] = useState(null);
  const [po_character_length, setPoCharacterLength] = useState(false);
  const [po_character_length_value, setPoCharacterLengthValue] = useState(0);
  const [po_must_have_numberonly, setPoHaveNumberOnly] = useState(false);
  const [po_error_message, setPoErrorMessage] = useState("");
  const [po_error_message_value, setPoErrorMessageValue] = useState("");
  const [po_payment_options, setPoPaymentOptions] = useState([]);
  const { checkOrderNoMandatory } = useGlobalFunction();
  const { orderid } = useParams();
  useEffect(() => {
    setIsMandatory(poNumberRequired);
  }, [poNumberRequired]);
  useEffect(() => {
    $("#purchase-order-cmt1").hide("slow");
    if (takePendingOrderCommentsOpen()) {
      $("#purchase-order-cmt1").stop(true, true).show();
    }
    console.log("PoNumber", poNumber);
    return () => {
      if (orderid == null) setPoNumber("");
    };
  }, []);

  useEffect(() => {
    if (poNumberRules) {
      const selectedPayments = selectedPaymentType ? normalizePath(PAYMENT_METHOD_STRING[selectedPaymentType]) : null;
      let rules = poNumberRules;
      if (
        (selectedPaymentType && normalizePath(rules?.po_payment_options ?? "") == selectedPayments) ||
        rules?.po_payment_options == "ALL"
      ) {
        setPoStartWith(rules?.po_start_with);
        setPoStartWithValue(rules?.po_start_with_value);
        setPoCharacterLength(rules?.po_character_length);
        setPoCharacterLengthValue(rules?.po_character_length_value);
        setPoHaveNumberOnly(rules?.po_must_have_number_only);
        setPoErrorMessage(rules?.po_error_message);
        setPoErrorMessageValue(rules?.po_error_message_value);
        setPoPaymentOptions(rules?.po_payment_options);
      } else {
        setPoStartWith(null);
        setPoStartWithValue(null);
        setPoCharacterLength(null);
        setPoCharacterLengthValue(null);
        setPoHaveNumberOnly(null);
        setPoErrorMessage(null);
        setPoErrorMessageValue(null);
        setPoPaymentOptions(null);
      }
    }
  }, [poNumberRules, selectedPaymentType]);

  const handleAddCommentsClick = () => {
    $("#purchase-order-cmt1").slideToggle("slow");
  };

  const handleOnChange = (e) => {
    let val = e.target.value;
    val = isAlphaNumericStrict(val);
    if (po_start_with == true && po_start_with_value != null) {
      val = poNumberStartWith(val, po_start_with_value);
    }
    if (po_must_have_numberonly) {
      val = IsNumberKey(val);
    }
    if (po_character_length == true && po_character_length_value) {
      val = val.slice(0, po_character_length_value);
    } else {
      val = val.slice(0, 23);
    }
    setPoNumber(val);
    debouncedFunction(val);
  };

  const debouncedFunction = useCallback(
    debounce(async (val) => {
      const res = await axiosInstance.post("Shipping/CheckOrderId", {
        userid: String(userId),
        purchaseOrderNumber: String(val),
      });
    }, 1000),
    [],
  );

  const checkConstrains = () => {
    if (po_character_length == true && po_character_length_value) {
      if (parseInt(poNumber.length) != parseInt(po_character_length_value)) $("#poNumbertextbox").focus();
    }
  };

  return (
    <Fragment>
      <div className="purchase-order">
        <h3>Purchase Order Number</h3>
        <div className="floating-input">
          <input
            id="poNumbertextbox"
            className="form-control form-input"
            type="text"
            placeholder={""}
            required={isMandatory}
            value={poNumber}
            onChange={handleOnChange}
          />

          <label htmlFor="poNumbertextbox">
            Customer PO Number
            {po_start_with == true ? " Must Start With '" + po_start_with_value + "'" : ""}{" "}
            {isMandatory == true && <span className="gl-form-asterisk">*</span>}
          </label>
          {error && <p style={{ color: "red", marginTop: "5px" }}>{error}</p>}
        </div>
      </div>
      {/* Purchase Order Number */}
      {/* Add Comments for WES */}
      <div className="order-cmt-wes">
        <button
          type="button"
          className="a-tag-button add-cmtNotes"
          id="add-cmtNotes"
          onClick={handleAddCommentsClick}
          style={{ width: "fit-content", display: "none" }}
        >
          Add Comments or Notes to WES
        </button>
        {/* Order Comments for WES */}
        <div className="purchase-order" id="purchase-order-cmt1">
          <h3>Order Comments for WES </h3>
          <div className="floating-input">
            <input
              id="form_orderComment"
              className="form-control form-input"
              type="text"
              placeholder=""
              required={true}
              value={orderCommands}
              onChange={(e) => {
                setOrderCommands(e.target.value);
              }}
              onBlur={checkConstrains}
            />
            <label htmlFor="form_orderComment">
              Enter Order Commands
              <span className="gl-form-asterisk" />
            </label>
          </div>
          <small>* Maximum 300 Characters</small>
        </div>
        {/* Order Comments for WES */}
      </div>
    </Fragment>
  );
};
